import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import { isInPageTransition } from '../lib/routes';
import { scrollToSection } from './fx/SmoothScroll';

const ScrollToTop = () => {
  const { pathname, hash } = useLocation();
  const prev = useRef(pathname);

  useEffect(() => {
    const prevPath = prev.current;
    prev.current = pathname;
    // ページ内の操作（メンバーモーダル・採用サイトのタブ）ではトップへ戻さない
    if (prevPath !== pathname && isInPageTransition(prevPath, pathname)) return undefined;
    window.scrollTo(0, 0);
    // /enablement#request のようなアンカー付きURLは、描画を待ってからその位置へ送る
    if (!hash) return undefined;
    const t = setTimeout(() => scrollToSection(decodeURIComponent(hash.slice(1))), 450);
    return () => clearTimeout(t);
  }, [pathname, hash]);

  return null;
};

export default ScrollToTop;
